(() => {
  const init = async (root) => {
    if (!root || root.dataset.valmontiRecommendationsReady || !root.dataset.url) return;
    root.dataset.valmontiRecommendationsReady = 'true';

    try {
      const response = await fetch(root.dataset.url);
      if (!response.ok) return;

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const loaded = documentFragment.querySelector('[data-valmonti-product-recommendations]');
      if (!loaded || !loaded.innerHTML.trim()) return;

      root.innerHTML = loaded.innerHTML;
      root.hidden = loaded.hidden;
      root.dispatchEvent(new CustomEvent('valmonti:carousel:refresh', { bubbles: true }));
    } catch {
      // Recommendations are an enhancement; the product page remains usable.
    }
  };

  const observe = (scope = document) => scope.querySelectorAll('[data-valmonti-product-recommendations]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
